export default {
      id: "Icon--nocturnal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--nocturnal",
      toString: function () {
        return this.url;
      }
    }